import { storyblokEditable } from '@storyblok/react';
import { motion } from 'framer-motion';
import { FC } from 'react';

import Container from '@/components/elements/Container';
import Prose from '@/components/elements/Prose';
import Section from '@/components/elements/Section';

export interface TextContentProps {
  blok: any;
  content: any;
}

const TextContent: FC<TextContentProps> = ({
  blok,
  content = blok.content,
}) => {
  return (
    <Section {...storyblokEditable(blok)} className="overflow-hidden">
      <Container size={'tightest'}>
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          whileInView={{
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.35,
            },
          }}
          viewport={{ once: true, margin: '200px' }}
        >
          {content && (
            <Prose
              size="base"
              center={true}
              content={content}
              animate={false}
            ></Prose>
          )}
        </motion.div>
      </Container>
    </Section>
  );
};

export default TextContent;
